export default "__VITE_ASSET__C$cE2MfO__"